import { ADMIN_APP_URL, AUTH_APP_URL } from "../config/config";
import { localStorageKeys } from "../constants/storage-keys";

export const redirectToAuth = () => {
  window.location.href = AUTH_APP_URL;
};

export const redirectToChangePassword = () => {
  const trainerUUID = localStorage.getItem(localStorageKeys.trainerUUID);
  const trainerToken = localStorage.getItem(
    localStorageKeys.trainerAccessToken
  );
  const params = new URLSearchParams({
    trainerAccessToken: trainerToken,
    trainerUUID: trainerUUID,
  });

  window.location.href = `${AUTH_APP_URL}/passwort-aendern?${params.toString()}`;
};

export const redirectToAdminApp = () => {
  const adminToken = localStorage.getItem(localStorageKeys.adminAccessToken);
  const trainerToken = localStorage.getItem(
    localStorageKeys.trainerAccessToken
  );
  const isAdmin = localStorage.getItem(localStorageKeys.isAdmin);
  const trainerUUID = localStorage.getItem(localStorageKeys.trainerUUID);

  const params = new URLSearchParams({
    adminAccessToken: adminToken,
    trainerAccessToken: trainerToken,
    trainerUUID: trainerUUID,
    isAdmin: isAdmin,
  });
  window.location.href = `${ADMIN_APP_URL}/auth?${params.toString()}`;
};
